import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const Home = () => import("@/views/Home");
const Production = () => import("@/views/Production");
const ThreeNav = () => import("@/views/ThreeNav");
const FourNav = () => import("@/views/FourNav");
const FiveNav = () => import("@/views/FiveNav");
const Demo = () => import("@/views/Demo");
const ProductionBrain = () =>
  import("@/components/production/ProductionBrain.vue");
const YunZhaoShang = () => import("@/components/yun_zhaoshang/index.vue");
const EnterInnovation = () => import("@/components/enter_innovation/index.vue");
const Consulting = () => import("@/components/consulting/index.vue");
const SouthAmerica = () => import("@/components/south_america/index.vue");
const ReportList = () => import("@/components/report_list/index.vue");
const NewsDetails = () => import("@/components/report_list/NewsDetails.vue");
const Realize = () => import("@/components/realize/index.vue");
const SpecialContainer = () => import("@/components/special_container/index.vue");
const SpecialContainerCase = () => import("@/components/special_container_case/index.vue");
const NewEnergyCase = () => import("@/components/new_energy_case/index.vue");
const NewEnergy = () => import("@/components/new_energy/index.vue");
const ContactUs = () => import("@/components/contact_us/index.vue");

const routes = [
  {
    path: "",
    redirect: "/home",
  },
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/home/index",
    component: Home,
  },
  {
    path: "/production",
    component: Production,
    children: [
      {
        path: "1",
        component: ProductionBrain,
      },
      {
        path: "2",
        component: YunZhaoShang,
      },
      {
        path: "3",
        component: EnterInnovation,
      },
      {
        path: "4",
        component: Consulting,
      },
      {
        path: "5",
        component: SouthAmerica,
      },
      {
        path: "6",
        component: SpecialContainer,
      },
      {
        path: "7",
        component: SpecialContainerCase,
      },
      {
        path: "8",
        component: NewEnergyCase,
      },
      {
        path: "9",
        component: NewEnergy,
      },
    ],
  },
  {
    path: "/threenav",
    component: ThreeNav,
  },
  {
    path: "/threenav/index",
    component: ThreeNav,
  },
  {
    path: "/fournav",
    component: FourNav,
    children: [
      {
        path: "1",
        component: ReportList,
      },
      {
        path: "2",
        component: ReportList,
      },
      {
        path: "3",
        component: ReportList,
      },
    ],
  },
  {
    path: "/fivenav",
    component: FiveNav,
    children: [
      {
        path: "1",
        component: Realize,
      },
      {
        path: "2",
        component: Realize,
      },
      {
        path: "3",
        component: Realize,
      },
      {
        path: "4",
        component: Realize,
      },
    ],
  },
  {
    path: "/demo",
    component: Demo,
  },
  {
    path: "/news_detail/:id",
    component: NewsDetails,
  },
  {
    path: "/contact_us",
    component: ContactUs,
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

export default router;
